import Turn from './Turn';

import { Spinner } from '@/app/ui/spinner';

/** Stands in for the answer while the assistant works on it. */
const Thinking = () => {
  return (
    <Turn role="status" data-testid="help-assistant-thinking">
      <div className="text-muted-foreground flex h-6 items-center gap-2.5 text-sm">
        <Spinner />
        Searching the help articles…
      </div>
    </Turn>
  );
};

export default Thinking;
